import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.41448 3.19526C9.67797 2.93491 10.1052 2.93491 10.3687 3.19526C10.6082 3.43194 10.63 3.80231 10.434 4.0633L10.3687 4.13807L6.62855 7.83333L10.3687 11.5286C10.6082 11.7653 10.63 12.1356 10.434 12.3966L10.3687 12.4714C10.1291 12.7081 9.75429 12.7296 9.49015 12.536L9.41448 12.4714L5.19761 8.30474C4.95808 8.06806 4.93631 7.69769 5.13229 7.4367L5.19761 7.36193L9.41448 3.19526Z"
      fill="#D24637"
    />
    <path
      d="M14.5855 11.5286C14.322 11.2682 13.8948 11.2682 13.6313 11.5286C13.3918 11.7653 13.37 12.1356 13.566 12.3966L13.6313 12.4714L17.3714 16.1667L13.6313 19.8619C13.3918 20.0986 13.37 20.469 13.566 20.73L13.6313 20.8047C13.8709 21.0414 14.2457 21.0629 14.5098 20.8693L14.5855 20.8047L18.8024 16.6381C19.0419 16.4014 19.0637 16.031 18.8677 15.77L18.8024 15.6953L14.5855 11.5286Z"
      fill="#6C9F14"
    />
    <path
      d="M18.3253 7.16667C18.6979 7.16667 19 7.46515 19 7.83334C19 8.17321 18.7426 8.45367 18.4099 8.49481L18.3253 8.50001H6.51808C6.14546 8.50001 5.84338 8.20153 5.84338 7.83334C5.84338 7.49347 6.10077 7.213 6.43345 7.17187L6.51808 7.16667H18.3253Z"
      fill="#D24637"
    />
    <path
      d="M18.3253 15.5C18.6979 15.5 19 15.7985 19 16.1667C19 16.5065 18.7426 16.787 18.4099 16.8281L18.3253 16.8333H6.51808C6.14546 16.8333 5.84338 16.5349 5.84338 16.1667C5.84338 15.8268 6.10077 15.5463 6.43345 15.5052L6.51808 15.5H18.3253Z"
      fill="#6C9F14"
    />
  </svg>
);

const IconSubstitution = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconSubstitution;
